import { Component, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { IAgreement } from '../../../../../models/interface/agreement.interface'
import { PriceSupportAgreementService } from '../../../../../services/agreement/price-support/price-support-agreement.service'

@Component({
    selector: 'app-update-account-number',
    templateUrl: './update-account-number.component.html',
    styleUrls: ['./update-account-number.component.scss'],
    standalone: false
})
export class UpdateAccountNumberComponent implements OnInit {
  public data: IAgreement
  public showLoader: boolean
  public disableOnSubmit: boolean
  public accountNumber: string
  public title = 'Add'

  constructor(
    public modal: NgbActiveModal,
    public priceSupportAgreementService: PriceSupportAgreementService
  ) {}

  ngOnInit(): void {
    this.accountNumber = this.data?.accountNumber || ''
    if (this.accountNumber) {
      this.title = 'Update'
    }
  }

  public updateAccountNumber(value: any): void {
    this.disableOnSubmit = true
    this.showLoader = true

    this.priceSupportAgreementService.updateAccountNumber(this.data?.orderCode, value.trim()).subscribe(
      () => {
        this.modal.close(true)
      },
      (err) => {
        this.modal.dismiss(err)
      }
    )
  }

  public get disableOnInvalidAccount(): boolean {
    if (this.accountNumber) {
      if (this.accountNumber.trim().length > 0) {
        return false
      }
    }
    return true
  }
}
